module.exports = __webpack_public_path__ + "img/edu.d1b8502c.svg";